import { ref } from 'vue'

export function useUrlParams() {

    const url    = new URL(window.location.href)
    const params = new URLSearchParams(url.search)

    const searchQuery = ref(null)

    const handleSearchQuery = ({ s }) => {
        if ( s && s.length ) {
            searchQuery.value.value = s
        }
    }

    const getParamsFromUrl = () => Object.fromEntries(params.entries())

    return {
        url,
        params,
        searchQuery,
        getParamsFromUrl,
        handleSearchQuery
    }
}
